import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../../_components/navbar/navbar.component';
import { FooterComponent } from '../../_components/footer/footer.component';
import { CookieConsentComponent } from '../../_components/cookie-consent/cookie-consent.component';

@Component({
    selector: 'app-main-layout',
    imports: [RouterOutlet, NavbarComponent, FooterComponent, CookieConsentComponent],
    template: `
    <a href="#contenu" (click)="skipToContent($event)"
      class="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-[70] focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:font-bold focus:text-primary focus:shadow-lg">
      Aller au contenu principal
    </a>
    <header>
      <app-navbar></app-navbar>
    </header>
    <main id="contenu" tabindex="-1" class="focus:outline-none">
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
    <app-cookie-consent></app-cookie-consent>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class MainLayoutComponent {
  /** Avec <base href="/">, un simple lien #ancre renverrait à l'accueil : on déplace le focus à la main. */
  skipToContent(event: Event): void {
    event.preventDefault();
    document.getElementById('contenu')?.focus();
  }
}